export default __webpack_public_path__ + "static/media/success-illus.61176510.svg";